import type { IOptions } from 'sanitize-html'

export const SanitizationPresets = {
  MissingPreset: 'MissingPreset',
  Strict: 'Strict',
  RichTextWithMedia: 'RichTextWithMedia',
  AllowClassesAndLinks: 'AllowClassesAndLinks',
} as const

export type SanitizationPresets = (typeof SanitizationPresets)[keyof typeof SanitizationPresets]

export type Preset = IOptions | false | undefined

type AllowedTags = Extract<
  keyof JSX.IntrinsicElements,
  'span' | 'div' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'td' | 'small' | 'strong' | 'em'
>
export type TrustedHtmlProps = {
  [K in AllowedTags]: { as?: K } & Omit<
    JSX.IntrinsicElements[K],
    'dangerouslySetInnerHTML' | 'children' | 'as' | 'ref' | 'value'
  >
}[AllowedTags] & { children: string; sanitizationPreset?: SanitizationPresets }
